export default __webpack_public_path__ + "static/ngo_mockup-aab00c75dd1fa5e3b76b2443137d9c17.png";